import {
  perimeterLinkLayer,
  perimeterLinkOutlineLayer,
  perimeterSensorIconLabelLayer,
  perimeterSensorIconLayer,
} from '@components/map/layers/perimeterSensors/perimeterSensor.layer';
import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useDisplayPerimeterLinksEvent } from '@hooks/useDisplayPerimeterLinksEvent';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectPerimeterLinkFeatures, selectPerimeterSensorFeatures } from '@redux/situation/monitoring.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { FeatureCollection } from 'geojson';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

function PerimeterSensorLayerContent() {
  const { viewState } = useMapContext();
  useDisplayPerimeterLinksEvent();

  const perimeterSensorFeatures = useSelectorWithReplayMode(selectPerimeterSensorFeatures);
  const perimeterLinkFeatures = useSelectorWithMapId(selectPerimeterLinkFeatures, viewState.zoom);

  const mergedFeatures: FeatureCollection = {
    ...perimeterSensorFeatures,
    features: [...perimeterSensorFeatures.features, ...perimeterLinkFeatures],
  };

  if (!isFeatureCollection(mergedFeatures)) return null;

  return (
    <Source id={SourceNameEnum.PERIMETER_SENSORS} type="geojson" data={mergedFeatures}>
      <Layer {...perimeterLinkOutlineLayer} />
      <Layer {...perimeterLinkLayer} />
      <Layer {...perimeterSensorIconLabelLayer} />
      <Layer {...perimeterSensorIconLayer} />
    </Source>
  );
}

export default function PerimeterSensorLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.PERIMETER_SENSORS)}>
      <PerimeterSensorLayerContent />
    </ErrorBoundary>
  ) : (
    <PerimeterSensorLayerContent />
  );
}
